import { Container, Sprite } from 'pixi.js';
import { SolitaireGame } from './SolitaireGame';
import { getAsset } from './preloadGameAssets';
import { areBoxesCollide } from './helpers/collision';
import { DropCardPlace, GamePlace } from 'constants/cards';
import { Layout } from './LayoutManager';
import { FOUNDATION_Z_INDEX } from 'constants/layout';
import { CARD_MOVE_TIME } from 'constants/move';
import gsap, { Power1 } from 'gsap';
import { GameBoardPlace } from './GameBoardPlace';
import { Card } from 'components/Card';
import { PlaceholdersAtlas } from './assets/generated';

export class FreeCell extends GameBoardPlace {
    placeholder: Container;
    placeholderSprite?: Sprite;

    constructor(parent: SolitaireGame, index: number) {
        super(parent, index, GamePlace.FREECELL);
        this.addCard = this.addCard.bind(this);
        this.container = new Container();
        this.placeholder = new Container();
        this.container.addChild(this.placeholder);
        this.game = parent;
        parent.gameContainer.addChild(this.container);
        this.drawPlaceholder();
        this.resize();
    }

    async drawPlaceholder() {
        const txt = await PlaceholdersAtlas.getTextureByName('slot-empty.png');

        this.placeholderSprite = Sprite.from(txt);
        this.placeholderSprite.anchor.set(0.5);

        this.placeholder.addChild(this.placeholderSprite);
        this.redrawPlaceholder();
    }
    redrawPlaceholder() {
        if (!this.placeholderSprite) return;
        const { width, height } = Layout.getCardSize();
        this.placeholderSprite.height = height;
        this.placeholderSprite.width = width;
    }

    overDropArea(container: Container) {
        return areBoxesCollide(this.placeholder, container);
    }

    refresh() {
        const position = Layout.getFreeCellPosition(this.index);

        gsap.to(this.container.position, {
            ...position,
            ease: Power1.easeOut,
            duration: CARD_MOVE_TIME,
        });
        this.redrawPlaceholder();
        if (this.lastCard) {
            this.lastCard.place.position = position;
            this.lastCard.moveTo(position);
            this.lastCard.cardDisplay.castShadow(true);
            this.lastCard.setActive(true);
        }
    }
    resize(): void {
        const position = Layout.getFreeCellPosition(this.index);

        this.container.position = position;
        this.redrawPlaceholder();
        if (this.lastCard) {
            this.lastCard.place.position = position;
            this.lastCard.setPosition(position);
            this.lastCard.cardDisplay.castShadow(true);
            this.lastCard.setActive(true);
        }
    }
    addCard(card: Card): void {
        super.addCard(card);
        card.setActive(true);
        card.place.zIndex = FOUNDATION_Z_INDEX + 1;
    }
    getPlace(): DropCardPlace {
        return { place: GamePlace.FREECELL, dropColumnIndex: this.index };
    }
    destroy() {
        this.container.removeFromParent();
    }
}
